import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { selectSelectedSection } from 'store/Schedule/selectors';
import CustomCronExpression from '../CustomCronExpression';
import {
  SetupSection, Subtitle, DescriptionSchedule, FieldWrapper, CustomRadioButton
} from './styled';

const CronExpression = ({
  onChangeCrontab, crontab, isCreateSchedule
}) => {
  const intl = useIntl();
  const section = useSelector(selectSelectedSection);
  const crontabName = get(crontab, 'name', '');
  const crontabExpression = get(crontab, 'expression', '');
  const [customValue, setCustomValue] = useState(isCreateSchedule ? '' : crontabExpression);
  const isCustomCrontab = () => get(crontab, 'name', 'day') === 'custom';
  const descriptionId = section === 'scheduledCloudAgents'
    ? 'schedule.createEditSchedule.cronDescription.securityScanners'
    : 'schedule.createEditSchedule.cronDescription.runners';

  useEffect(() => {
    if (crontabName === 'custom') {
      setCustomValue(crontabExpression);
      return;
    }

    if (crontabExpression) {
      setCustomValue(crontabExpression);
    }
  }, [crontabExpression, crontabName]);

  if (isEmpty(crontab)) return null;
  return (
    <SetupSection>
      <Subtitle>{ intl.formatMessage({ id: 'schedule.createEditSchedule.setupSchedule' }) }</Subtitle>
      <DescriptionSchedule>{ intl.formatMessage({ id: descriptionId }) }</DescriptionSchedule>
      <FieldWrapper>
        <CustomRadioButton id="scheduler-modal-radio-day" label={ intl.formatMessage({ id: 'schedule.createEditSchedule.radio.day' }) } name="radio" value="0 4 * * *" onChange={ (e) => onChangeCrontab({ name: 'day', expression: e.target.value }) } checked={ crontab.name === 'day' } />
        <CustomRadioButton id="scheduler-modal-radio-week" label={ intl.formatMessage({ id: 'schedule.createEditSchedule.radio.week' }) } name="radio" value="0 4 * * 0" onChange={ (e) => onChangeCrontab({ name: 'week', expression: e.target.value }) } checked={ crontab.name === 'week' } />
        <CustomRadioButton id="scheduler-modal-radio-month" label={ intl.formatMessage({ id: 'schedule.createEditSchedule.radio.month' }) } name="radio" value="0 4 1 * *" onChange={ (e) => onChangeCrontab({ name: 'month', expression: e.target.value }) } checked={ crontab.name === 'month' } />
        <CustomRadioButton $mandatory id="scheduler-modal-radio-custom" label={ intl.formatMessage({ id: 'schedule.createEditSchedule.radio.custom' }) } name="radio" value={ customValue } onChange={ (e) => onChangeCrontab({ name: 'custom', expression: e.target.value }) } checked={ isCustomCrontab() } />
        <CustomCronExpression id="scheduler-modal-input-custom" value={ isCustomCrontab() ? customValue : '' } setValue={ setCustomValue } onCancel={ () => onChangeCrontab({ name: 'day', expression: '0 4 * * *' }) } onChangeCustomCronExpression={ (value) => onChangeCrontab({ name: 'custom', expression: value }) } disabled={ !isCustomCrontab() } />
      </FieldWrapper>
    </SetupSection>
  );
};

export default CronExpression;
